import request from '@/request'
import isotope from 'vueisotope'
import { CardLG as Card, PublicHeader } from '../../../../components/common/'

export default {
  name: 'educacao',
  components: {
    isotope,
    Card,
    PublicHeader
  },
  data () {
    return {
      model: {
        lista_escolas: [],
        totalAlunos: 0,
        lista_bairros: [],
        lista_ensinos: [],
        filtros: {
          bairro: null,
          ensino: null,
          escola: null
        }
      },
      filterText: '',
      filterOption: 'filterByText'
    }
  },
  methods: {
    retira_acentos(str) {
      const parsed = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return parsed
    }, 
    getOptions() {
      var _this = this
      return {
        getSortData: {
          id: "id",
          name: function(itemElem) {
            return itemElem.codigo.toLowerCase()
          }
        },
        getFilterData: {
          isEven: function(itemElem) {
            return itemElem.codigo % 2 === 0
          },
          isOdd: function(itemElem) {
            return itemElem.codigo % 2 !== 0
          },
          filterByText: function(itemElem) {
            return (
              _this.retira_acentos(itemElem.nome.toLowerCase()).includes(_this.textoFiltrado) ||
              _this.retira_acentos(itemElem.nomeconhecido.toLowerCase()).includes(_this.textoFiltrado)
            )
          }
        }
      }
    },
    listarBairros() {
      var bairros = this.$refs.bairros
      bairros.toggleLoading()
      request.get(
        'educacao/listarBairros',
        response => {
          this.model.lista_bairros = response.data
          bairros.toggleLoading()
        },
        response => {
          console.log(response)
          bairros.toggleLoading()
        }
      )
    },
    listarEnsinos() {
      var ensinos = this.$refs.ensinos
      ensinos.toggleLoading()
      request.get(
        'educacao/listarEnsinos',
        response => {
          this.model.lista_ensinos = response.data
          ensinos.toggleLoading()
        },
        response => {
          console.log(response)
          ensinos.toggleLoading()
        }
      )
    },
    listarEscolas() {
      let params = '?'
      this.filterText = ''
      this.model.lista_escolas = []
      this.model.totalAlunos = 0

      if (this.model.filtros.bairro) {
        params += '&bairro=' + this.model.filtros.bairro.codigo
      }

      if (this.model.filtros.ensino) {
        params += '&ensino=' + this.model.filtros.ensino.codigo
      }

      // if (this.model.filtros.escola) {
      //   params += '&escola=' + this.model.filtros.escola.codigo
      // }

      request.get(
        'educacao/listarEscolas' + params,
        response => {
          this.model.lista_escolas = response.data
          this.totalAlunos()
        },
        response => {
          console.log(response)
        }
      )
    },
    totalAlunos() {
      request.get(
        'educacao/totalAlunos?escolas=' + this.escolasListadas,
        response => {
          this.model.totalAlunos = response.data
        },
        response => {
          console.log(response)
        }
      )      
    },
    carregarLista(url, callback) {
      request.get(
        url,
        response => {
          callback(response.data)
        },
        response => {
          callback(console.log(response))
        }
      )
    },
  },
  computed: {
    textoFiltrado() {
      return this.retira_acentos(this.filterText.toLowerCase())
    },

    formatTotalAlunos() {
      var nf = Intl.NumberFormat('pt-BR')
      return nf.format(this.model.totalAlunos)
    },

    escolasListadas() {
      let esc = []
      for (let index = 0; index < this.model.lista_escolas.length; index++) {
        esc.push(this.model.lista_escolas[index].codigo)
      }

      return encodeURIComponent(JSON.stringify(esc))
    }
  },
  mounted () {
    this.listarEscolas()
    this.listarBairros()
    this.listarEnsinos()
  }
}



// WEBPACK FOOTER //
// ./src/views/public/educacao/dashboard/dashboard.js